module.exports = __webpack_public_path__ + "img/qg-logo_trans-1a.7a4c959b.png";